var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgValuacionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "IconAdicionales/Valuacion"
  }, /*#__PURE__*/React.createElement("path", {
    id: "IconAdicionales/Valuacion_2",
    d: "M0.125 19.79V21.875C0.125 23.5986 4.32422 25 9.5 25C14.6758 25 18.875 23.5986 18.875 21.875V19.79C16.8584 21.2109 13.1719 21.875 9.5 21.875C5.82812 21.875 2.1416 21.2109 0.125 19.79ZM15.75 6.25C20.9258 6.25 25.125 4.84863 25.125 3.125C25.125 1.40137 20.9258 0 15.75 0C10.5742 0 6.375 1.40137 6.375 3.125C6.375 4.84863 10.5742 6.25 15.75 6.25ZM0.125 14.668V17.1875C0.125 18.9111 4.32422 20.3125 9.5 20.3125C14.6758 20.3125 18.875 18.9111 18.875 17.1875V14.668C16.8584 16.3281 13.167 17.1875 9.5 17.1875C5.83301 17.1875 2.1416 16.3281 0.125 14.668ZM20.4375 15.2051C23.2354 14.6631 25.125 13.6572 25.125 12.5V10.415C23.9922 11.2158 22.3271 11.7627 20.4375 12.0996V15.2051ZM9.5 7.8125C4.32422 7.8125 0.125 9.56055 0.125 11.7188C0.125 13.877 4.32422 15.625 9.5 15.625C14.6758 15.625 18.875 13.877 18.875 11.7188C18.875 9.56055 14.6758 7.8125 9.5 7.8125ZM20.208 10.5615C23.1377 10.0342 25.125 8.99902 25.125 7.8125V5.72754C23.3916 6.95312 20.4131 7.61231 17.2783 7.76856C18.7188 8.4668 19.7783 9.4043 20.208 10.5615Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValuacionIcon);
export default __webpack_public_path__ + "static/media/valuacion_icon.457d44bb56314b761a0a09c0e297c2d0.svg";
export { ForwardRef as ReactComponent };